import { init as validation } from "./form/validation"

export const init = () => {
  validation()
}